import { memo } from 'react'
// import { useGlobalStore } from "../../../store/global-store";
// import { Toast } from "./components/toast";
import { useShallow } from 'zustand/react/shallow'
import { useGlobalStore } from '../../../store/global-store'
import { Toast } from './components/toast'
import { useUpdateGiftReturnLuck } from './use-update-gift-return-luck'

export const GiftReturnLuck = memo(() => {
  useUpdateGiftReturnLuck()

  const notifyGiftSentReturnList = useGlobalStore(
    useShallow((state) => {
      return state.notifyGiftSentReturnList
    }),
  )

  if (notifyGiftSentReturnList) {
    return (
      <div className="w-screen h-screen flex justify-center flex-col gap-2 -mt-36">
        <Toast
          key={notifyGiftSentReturnList.id}
          toast={notifyGiftSentReturnList}
        />
      </div>
    )
  }
})
